import styled from '@emotion/styled';

export const Wrapper = styled.div`
  height: 64px;
  width: 100%;
  background-color: #0e1216;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
`;
